import React from 'react'
import KnowledgeHero from './KnowledgeProcess/KnowledgeHero'
import KnowledgeSection from './KnowledgeProcess/KnowledgeSection'
import KnowledgeTrust from './KnowledgeProcess/KnowledgeTrust'
import Footer from '../../Component/Footer/Footer'



function KnowledgeKPO() {
    return (
        <div>
            <KnowledgeHero/>
            <KnowledgeSection/>
            <KnowledgeTrust/>
            <Footer/>
        </div>
    )
}

export default KnowledgeKPO
